import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Select, Store} from '@ngxs/store';
import {DictionaryState} from '../../../../state/dictionary/dictionary.state';
import {DictionaryCode} from '../../../../enums/dictionary-code.enum';
import {Observable, Subscription} from 'rxjs';
import {Dictionary} from '../../../../models/dictionary.model';
import {ValidatableFormComponent} from '../validatable-form';
import {SalesCpiAsideState} from '../../../../state/sales-cpi/sales-cpi-aside.state';

@Component({
    selector: 'app-cpi-party-form',
    templateUrl: './cpi-party-form.component.html',
})
export class CpiPartyFormComponent extends ValidatableFormComponent implements OnInit, OnDestroy {
    @Select(DictionaryState.getDictionary(DictionaryCode.GENDER)) genderDictionary$: Observable<Dictionary>;
    @Select(DictionaryState.getDictionary(DictionaryCode.CITIZENSHIP)) citizenshipDictionary$: Observable<Dictionary>;
    @Select(DictionaryState.getDictionary(DictionaryCode.DOCUMENT_TYPE)) documentTypeDictionary$: Observable<Dictionary>;
    @Input() formGroup: FormGroup = new FormGroup({});
    @Input() hiddenFields: string[] = [];
    @Input() prefix = 'party.';
    @Input() disablePesel = false;

    private subscriptions: Subscription = new Subscription();

    polish = true;
    protected errors = {};
    addressHiddenFields = ['postOffice', 'voivodeship'];
    addressTooltips = {
        postalCode: 'SALES_CPI.TOOLTIP.ADDRESS_POST_CODE',
        city: 'SALES_CPI.TOOLTIP.ADDRESS_CITY',
        streetPrefix: 'SALES_CPI.TOOLTIP.ADDRESS_STREET_PREFIX',
        street: 'SALES_CPI.TOOLTIP.ADDRESS_STREET',
        streetNumber: 'SALES_CPI.TOOLTIP.ADDRESS_STREET_NUMBER',
        apartmentNumber: 'SALES_CPI.TOOLTIP.ADDRESS_APARTMENT_NUMBER',
        country: 'SALES_CPI.TOOLTIP.ADDRESS_COUNTRY',
    };

    constructor(private store: Store) {
        super(store.select(SalesCpiAsideState.formErrors));
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.formGroup.get(`${this.prefix}citizenship`).valueChanges.subscribe(value => this.updateForm(value))
        );
        this.updateForm(this.formGroup.get(`${this.prefix}citizenship`).value);
    }

    private updateForm(value: any) {
        this.polish = (value?.code ?? 'PL') === 'PL';
        const peselEnabled = this.polish && !this.disablePesel;
        this.setEnabledOnControl(`${this.prefix}pesel`, peselEnabled);
        this.setEnabledOnControl(`${this.prefix}birthDate`, !this.polish);
        // this.setEnabledOnControl(`${this.prefix}gender`, !this.polish);
        this.setEnabledOnControl(`${this.prefix}documentType`, !this.polish);
        this.setEnabledOnControl(`${this.prefix}documentNumber`, !this.polish);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
}
